import React from 'react'
import notFoundImg from '../../src/assets/images/png/NotFound.jpg' // adjust path if needed

const NotFound = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <img
        src={notFoundImg}
        alt='Page Not Found'
        style={{ maxWidth: '400px', width: '80%' }}
      />
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
  )
}

export default NotFound
